import axios from "axios";

export const sendAnalyticEvent = (id) => {
  axios.post("/api/v1/analytics/events", {
    events: {
      data: {
        timestamp: Date.now(),
        type: "application_form_flow",
        data: {
          name: "failed",
          source_id: id,
        },
      },
    },
  });
};
